import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "ck77nh6";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    height,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const style = {
    height
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(containerCss, props.className)} />;
});
const virtualListContainerCss = "vq51zii";
export const VirtualListContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    height,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const style = {
    height: `${height}px`
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(virtualListContainerCss, props.className)} />;
});
const virtualRowContainerCss = "vqcli4r";
export const VirtualRowContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    offset,
    height,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const style = {
    transform: `translateY(${offset}px)`,
    height: `${height}px`
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(virtualRowContainerCss, props.className)} />;
});
const virtualItemContainerIsLeftCss = "vopd8v9";
const virtualItemContainerIsCenterCss = "v1i4w9e4";
const virtualItemContainerIsRightCss = "v1owjrge";
const virtualItemContainerCss = "vvhxwc6";
export const VirtualItemContainer = forwardRef((props, ref) => {
  const {
    isLeft,
    isCenter,
    isRight,
    as: AsComponent,
    width,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const style = {
    width
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(virtualItemContainerCss, {
    [virtualItemContainerIsLeftCss]: isLeft,
    [virtualItemContainerIsCenterCss]: isCenter,
    [virtualItemContainerIsRightCss]: isRight
  }, props.className)} />;
});
const loadingContainerCss = "ltvjb2f";
export const LoadingContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    totalHeight,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const style = {
    transform: `translateY(${totalHeight}px)`
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(loadingContainerCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");